module.exports = __webpack_public_path__ + "static/media/KimberleyEcho-devicecomp-min@2x.15b2b9f4.png";